<template>
  <div class="footer">
    <div class="row">
      <div class="col-lg">
        <h2 class="footer-h2 wow animated fadeInLeft">{{$t('footer.title')}}</h2>
        <h3 class="footer-h3 wow animated fadeInRight">{{$t('footer.subtitle')}}</h3>
        <div class="footer-btn-div row wow animated fadeInRight">
          <button class="btn-first" @click="showDialog">{{$t('footer.try')}}</button>
          <button @click="toPath('/buy')">{{$t('footer.buy')}}</button>
        </div>
      </div>
      <div class="row footer-div">
        <div class="col-lg-4 col-md-4 col-xs-12 footer-div-wrap">
          <img id="footer-logo" src="../../static/images/footer-logo.png" alt align="left" />
          <p id="footer-left-p-language">{{$t('footer.lang')}}</p>
          <el-select class="white" v-model="value" :placeholder="$t('footer.langSelect')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <p id="footer-left-p-follow">{{$t('footer.follow')}}</p>
          <div class="footer-follow-us-div">
            <span
              @click="toUrl('https://www.linkedin.com/company/suzhou-gstarsoft-co-ltd/')"
              class="icon iconfont viewlinkedin"
            ></span>
            <span
              @click="toUrl('https://www.youtube.com/channel/UCtYObLC_uoUtObVFx71Tn9w')"
              class="icon iconfont viewyoutube"
            ></span>
            <span
              @click="toUrl('https://www.facebook.com/cadwonder/')"
              class="icon iconfont viewicon_facebook"
            ></span>
            <span
              @click="toUrl('https://twitter.com/Gstarsoft_CAD')"
              class="icon iconfont viewtwitter"
            ></span>
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-xs-12 nopadding sm-nopadding">
          <div class="col-lg-4 col-md-4">
            <h3 class="footer-right-h3" @click="openMenu('product')">
              {{$t('footer.products.name')}}
              <span class="icon iconfont viewarrow-down"></span>
            </h3>
            <div class="footer-right-div" id="product">
              <p @click="toUrl('http://view.cadwonder.net/')">{{$t('footer.products.plus')}}</p>
            </div>
            <div class="footer-right-div" id="product">
              <p @click="toPath('/')">{{$t('footer.products.d3')}}</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-4">
            <h3 class="footer-right-h3" @click="openMenu('document')">
              {{$t('footer.documents.name')}}
              <span class="icon iconfont viewarrow-down"></span>
            </h3>
            <div class="footer-right-div" id="document">
              <p @click="toPath('/support/need/guide')">{{$t('footer.documents.document')}}</p>
              <p
                @click="toPath('/support/need/videotutorials')"
              >{{$t('footer.documents.resources')}}</p>
              <p @click="toPath('/support/need/emailus')">{{$t('footer.documents.contact')}}</p>
              <p @click="openEmail()">{{$t('footer.documents.request')}}</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-4">
            <h3 class="footer-right-h3" @click="openMenu('studies')">
              {{$t('footer.case')}}
              <span class="icon iconfont viewarrow-down"></span>
            </h3>
            <div class="footer-right-div" v-for="item in caseList" :key="item.id" id="studies">
              <p @click="toPage(item.id)">{{item.shortTitle}}</p>
            </div>
          </div>
        </div>
      </div>
      <p id="copy">©Copyright 2019 Gstarsoft Co.,Ltd. All rights reserved.</p>
    </div>

    <!-- <p class="rightcopy wow fadeIn">©2010-2018 GSTAR</p> -->
  </div>
</template>

<script>
import { searchContent } from "../utils/http/loadData";
import { WOW } from "wowjs";
export default {
  data() {
    return {
      value: "en",
      options: [
        {
          value: "en",
          label: "English"
        },
        // {
        //   value: "kr",
        //   label: "한국어"
        // }
      ],
      caseList: ""
    };
  },
  methods: {
    openMenu(id) {
      let dom = document.querySelector("#" + id).children;
      for (let index = 0; index < dom.length; index++) {
        const element = dom[index];
        // element.style.display===''?'block':''
        console.log(element.style.display);
        if (element.style.display === "") {
          console.log("ok");
          element.style.display = "block";
        } else {
          element.style.display = "";
          console.log("no");
        }
      }
      // console.log(document.querySelector('#'+id).children[0].style.display='block')
    },
    openEmail(){
      console.log(this.$parent.openDia())
    },
    initCase() {
      searchContent("case", "en", 0, 3).then(res => {
        console.log(res);
        if (res.data.rtnCode === "0000000") {
          this.caseList = res.data.bizData.list;
        }
      });
    },
    toPage(id) {
      this.$router.push("/case/" + id);
    },
    toPath(path) {
      this.$router.push(path);
    },
    toUrl(path) {
      window.location.href = path;
    },
    showDialog() {
      this.$parent.showDialog();
    }
  },
  created() {
    this.initCase();
  },
  mounted() {
    new WOW().init();
  }
};
</script>

<style lang="scss">
@import "../../static/css/foot.scss";
</style>




// WEBPACK FOOTER //
// src/components/FooterBar.vue